// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"4605b553","850":"c01e4e54"}[chunkId] + ".chunk.js";
};